export default __webpack_public_path__ + "static/media/pipe.e0502bf6.svg";